import { MouseEvent } from 'react';

import { Flex, Image } from '@chakra-ui/react';

import { Radio } from 'uiToolkitV1/Radio';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export interface RadioCardProps {
  title: React.ReactNode;
  subText?: React.ReactNode;
  checked?: boolean;
  imgSrc?: any;
  onClick?: (e?: MouseEvent<HTMLDivElement>) => any;
  isDisabled?: boolean;
  additionalContent?: React.ReactNode;
  [key: string]: any;
}

export const RadioCard = ({
  title,
  subText,
  checked,
  imgSrc,
  isDisabled = false,
  onClick = null,
  additionalContent = null,
  ...props
}: RadioCardProps) => (
  <Flex
    bg="white"
    border="1px solid"
    borderColor={checked ? 'border.125AA9' : 'border.EBEFF3'}
    padding={3}
    borderRadius="8px"
    cursor={onClick ? 'pointer' : 'not-allowed'}
    onClick={onClick}
    alignItems="flex-start"
    _hover={{ borderColor: 'border.125AA9' }}
    h="140px"
    {...props}
  >
    <Flex
      opacity={isDisabled ? 0.75 : 1}
      alignItems="flex-start"
      pointerEvents={onClick ? 'auto' : 'none'}
      flexGrow={1}
    >
      {imgSrc && <Image src={imgSrc} borderRadius="4px" alt="" width="60px" />}

      <Flex flexDirection="column" ml={3}>
        <TextBodyMedium mb={1} bold>
          {title}
        </TextBodyMedium>
        <TextLabel color="text.g2" mb={2}>
          {subText}
        </TextLabel>
        {additionalContent}
      </Flex>
    </Flex>
    <Radio name="" onChange={() => {}} isChecked={checked} m="2px" />
  </Flex>
);
